




import Blockly from 'blockly'
import * as Ja from 'blockly/msg/ja'
import { defineComponent, onMounted, ref, inject } from '@vue/composition-api'
import { key } from '../store'

export default defineComponent({
  name: 'ShowBlock',
  props: {
    mode: {
      type: String,
      default: 'qrToCode',
    },
  },
  setup(props) {
    const store = inject(key)
    if (!store) {
      throw new Error('')
    }

    const createTheme = (): Blockly.Theme => {
      // Blockly.HSV_SATURATION = 0.8
      // Blockly.HSV_VALUE = 1
      {/* @ts-ignore */} // eslint-disable-line
      const baseTheme = Blockly.Themes.Deuteranopia
      const thema = Blockly.Theme.defineTheme('customize_theme', {
        base: baseTheme,
        blockStyles: {
          logic_blocks: {
            colourPrimary: '#20e6d8',
            colourSecondary: '#20e6d8',
            colourTertiary: '#20e6d8',
          },
          loop_blocks: {
            colourPrimary: '#20e6d8',
            colourSecondary: '#20e6d8',
            colourTertiary: '#20e6d8',
          },
          math_blocks: {
            colourPrimary: '#83e620',
            colourSecondary: '#83e620',
            colourTertiary: '#83e620',
          },
        },
      })
      return thema
    }

    let workspace = ref<Blockly.WorkspaceSvg>()
    onMounted(() => {
      Blockly.setLocale(Ja)
      Blockly.defineBlocksWithJsonArray([
        { type: 'meirei', message0: 'めいれい %1', args0: [{ type: 'input_statement', name: 'commands' }], colour: '#20e6db', tooltip: '', helpUrl: '' },
        { type: 'pose_human', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_human.png', width: 100, height: 100, alt: '直立したポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
        { type: 'pose_lion', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_lion.png', width: 100, height: 100, alt: 'ライオンのように肘を曲げて両手を挙げたポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
        { type: 'pose_bird', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_bird.png', width: 100, height: 100, alt: 'トリのように両手を伸ばして挙げたポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
        { type: 'pose_rabbit', message0: '%1', args0: [{ type: 'field_image', src: '/img/pose_blocks/pose_rabbit.png', width: 100, height: 100, alt: 'ウサギのように手を耳に当てるポーズ', flipRtl: false }], previousStatement: null, nextStatement: null, colour: '#2090e6', tooltip: '', helpUrl: '' },
      ])
      workspace.value = Blockly.inject('blocklyDiv', {
        readOnly: true,
        zoom: { controls: true, maxScale: 1.5 },
      })

      if (store.state.blocklyTheme === null) {
        store.setBlocklyTheme(createTheme())
      }
      if (store.state.blocklyTheme) {
        workspace.value.setTheme(store.state.blocklyTheme)
      }

      if ((props.mode === 'qrToCode' && store.state.qrCode === '') || (props.mode === 'codeToCode' && store.state.blocks === '')) {
        return
      }
      if (props.mode === 'qrToCode') {
        const xml = Blockly.Xml.textToDom(store.state.qrCode)
        Blockly.Xml.domToWorkspace(xml, workspace.value)
      }
      if (props.mode === 'codeToCode') {
        const xml = Blockly.Xml.textToDom(store.state.blocks)
        Blockly.Xml.domToWorkspace(xml, workspace.value)
      }
      workspace.value.zoomToFit()
    })
  },
})
